module.exports = __webpack_public_path__ + "static/img/Ryan-Gilder.22a893b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Ryan-Gilder.jpg
// module id = Qbhf
// module chunks = 0